export const PHONE_NUMBER = "8690955575"
export const EMERGENCY_CONTACT_NUMBER = "+91 8690955575"
export const EMERGENCY_CONTACT_NUMBER2 = "+91 9922566050"

// Section Id's
export const HOME_SECTION_ID = "banner-section"
export const ABOUTUS_SECTION_ID = "aboutus-section"
export const SERVICE_SECTION_ID = "service-section"
export const TESTIMONIAL_SECTION_ID = "testimonial-section"
export const BLOGS_SECTION_ID = "blogs-section"
export const CONTACTUS_SECTION_ID = "contact-section"